import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './form-container-related-links.component.scss';
import * as _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
var FormContainerRelatedLinks = /** @class */ (function (_super) {
    tslib_1.__extends(FormContainerRelatedLinks, _super);
    function FormContainerRelatedLinks(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    FormContainerRelatedLinks.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.modals = Array.from(this.element.querySelectorAll('.js-apply-now-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-relatedLinks-modal-open'));
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.relatedLinksContainer = this.element.querySelector('.related__links');
        this.relatedLinksModalsContainer = this.element.querySelector('.related__links-modals');
        this.modalButtons = Array.from(this.element.querySelectorAll('.js-rlinks-show-form'));
        this.publicHolidays = ['2018/01/01', '2018/03/21', '2018/03/30', '2018/04/02', '2018/04/27', '2018/05/01', '2018/06/16', '2018/08/09', '2018/09/24', '2018/12/16', '2018/12/17', '2018/12/25', '2018/12/26'];
        // DATE PICKER
        $(document).ready(function () {
            $('input.js-date-picker').datepicker({
                todayHighlight: true,
                format: 'yyyy/mm/dd',
                daysOfWeekDisabled: [0, 6],
                enableOnReadonly: true,
                autoclose: true
            }).on('changeDate', function (event) {
                var _event;
                if (typeof window.event === 'function') {
                    _event = new Event('change');
                    this.dispatchEvent(_event);
                }
                else {
                    _event = document.createEvent('HTMLEvents');
                    _event.initEvent('change', false, false);
                    this.dispatchEvent(_event);
                }
            });
        });
        TooltipsService.initTooltips();
    };
    FormContainerRelatedLinks.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.modalButtons.map(function (pButton) {
            pButton.addEventListener('click', function (pEvent) {
                if (_this.relatedLinksContainer) {
                    _this.relatedLinksContainer.classList.add('form-container-related-links__hidden');
                }
                if (_this.relatedLinksModalsContainer) {
                    _this.relatedLinksModalsContainer.classList.remove('form-container-related-links__hidden');
                }
                _this.currentModal = pEvent.target.closest('.modal__dialog');
                if (_this.currentModal) {
                    _this.currentModal.classList.add('modal__dialog--small');
                    _this.currentModal.classList.remove('modal__dialog--large');
                }
            });
        });
        document.addEventListener('click', function (e) {
            var composedPath = function (el) {
                var path = [];
                while (el) {
                    path.push(el);
                    if (el.tagName === 'HTML') {
                        path.push(document);
                        path.push(window);
                        return path;
                    }
                    el = el.parentElement;
                }
            };
            var path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
            var hasClass = function (cls) {
                return _.filter(path, function (p) {
                    var exists = false;
                    _.each(p.classList, function (cl) {
                        if (cl === cls) {
                            exists = true;
                        }
                    });
                    if (p.classList && exists) {
                        return p;
                    }
                })[0];
            };
            if (hasClass('js-apply-now-modal-open')) {
                _this.openModals(e);
            }
        }, false);
    };
    FormContainerRelatedLinks.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    FormContainerRelatedLinks.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-apply-now-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    FormContainerRelatedLinks.prototype.closeModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    FormContainerRelatedLinks.prototype.openModal = function () {
        var _this = this;
        if (this.activeModal) {
            this.formDatePicker = this.activeModal.querySelector('.js-date-picker');
            this.formTimePicker = this.activeModal.querySelector('.js-time-picker');
            if (this.formDatePicker) {
                this.formDatePicker.addEventListener('change', function (event) {
                    _this.validateDate(event.target);
                });
                if (this.formTimePicker) {
                    this.formDatePicker.classList.remove('form__input--required');
                    this.formTimePicker.addEventListener('change', function (event) {
                        if (event.currentTarget.value === 'Anytime') {
                            _this.formDatePicker.classList.remove('form__input--required');
                        }
                        else {
                            _this.formDatePicker.classList.add('form__input--required');
                        }
                    });
                }
            }
            this.resetForm();
            this.populateDatePicker();
            this.activeModal.classList.remove('modal--close');
            this.activeModal.classList.remove('modal--closed');
        }
    };
    FormContainerRelatedLinks.prototype.getModalById = function (id) {
        return document.getElementById(id);
    };
    FormContainerRelatedLinks.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            if (formContainerLoader) {
                formContainerLoader.classList.remove('active');
            }
            if (formContainerThankyou) {
                formContainerThankyou.classList.remove('active');
            }
            if (formContainerFields) {
                formContainerFields.classList.remove('hidden');
            }
            // allow individual form items components to handle form reset
            var event_1 = new Event('custom_form_reset_event');
            this.form.dispatchEvent(event_1);
        }
        if (this.relatedLinksContainer) {
            this.relatedLinksContainer.classList.remove('form-container-related-links__hidden');
        }
        if (this.relatedLinksModalsContainer) {
            this.relatedLinksModalsContainer.classList.add('form-container-related-links__hidden');
        }
        if (this.currentModal) {
            this.currentModal.classList.remove('modal__dialog--small');
            this.currentModal.classList.add('modal__dialog--large');
        }
    };
    FormContainerRelatedLinks.prototype.populateDatePicker = function () {
        if (this.formDatePicker) {
            this._startDate = this.validateDate();
            $(this.formDatePicker).datepicker('setStartDate', this._startDate).datepicker('setDatesDisabled', this.publicHolidays);
        }
    };
    FormContainerRelatedLinks.prototype.validateDate = function (_setDate) {
        if (_setDate === void 0) { _setDate = ''; }
        var _enabledOptions = false;
        var _currentDateTime = new Date();
        var _currentHour = _currentDateTime.getHours();
        var _currentMin = _currentDateTime.getMinutes();
        if (_setDate !== '') {
            var _selectedDate = new Date(_setDate.value);
            var _tmpSelectedDate = _selectedDate.getFullYear() + '/' + _selectedDate.getMonth() + '/' + _selectedDate.getDate();
            var _tmpCurrentDate = _currentDateTime.getFullYear() + '/' + _currentDateTime.getMonth() + '/' + _currentDateTime.getDate();
            _currentDateTime.setFullYear(_selectedDate.getFullYear(), _selectedDate.getMonth(), _selectedDate.getDate());
            if (_tmpSelectedDate !== _tmpCurrentDate) {
                _currentHour = 7;
                _currentMin = 0;
                _enabledOptions = true;
            }
            else {
                _enabledOptions = false;
            }
        }
        if (_currentHour >= 16) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
            _currentMin = 0;
        }
        if ((_currentMin >= 30) && (_currentHour <= 15)) {
            _currentHour++;
        }
        else if ((_currentMin >= 30) && (_currentHour >= 15)) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
            _currentHour = 7;
        }
        var _currentDayBefore = _currentDateTime.getDay();
        if (_currentDayBefore === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayBefore === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
        if (this.publicHolidays) {
            this.publicHolidays.forEach(function (holiday) {
                if (_currentDate === holiday) {
                    _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    var _currentDay = _currentDateTime.getDay();
                    if (_currentDay === 0) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 1);
                    }
                    else if (_currentDay === 6) {
                        _currentDateTime.setDate(_currentDateTime.getDate() + 2);
                    }
                    _currentDate = _currentDateTime.getFullYear() + '/' + ('0' + (_currentDateTime.getMonth() + 1)).slice(-2) + '/' + ('0' + _currentDateTime.getDate()).slice(-2);
                    _currentHour = 7;
                    _currentMin = 0;
                }
            });
        }
        var _currentDayAfter = _currentDateTime.getDay();
        if (_currentDayAfter === 0) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 1);
        }
        else if (_currentDayAfter === 6) {
            _currentDateTime.setDate(_currentDateTime.getDate() + 2);
        }
        var item = this.formTimePicker;
        var _tmpTime = ((_currentHour >= 10) ? (_currentHour + ':00:00') : ('0' + _currentHour + ':00:00'));
        for (var i = item.options.length - 1; i >= 0; i--) {
            if (item.options[i].value !== 'Anytime') {
                if ((item.options[i].value < _tmpTime) && (_enabledOptions === false)) {
                    item.options[i].disabled = true;
                }
                else if (_enabledOptions === true) {
                    item.options[i].disabled = false;
                }
            }
        }
        return _currentDateTime;
    };
    return FormContainerRelatedLinks;
}(Base));
export { FormContainerRelatedLinks };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-container-related-links/form-container-related-links.component.ts
// module id = 817
// module chunks = 0